import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Button, Dropdown, Form, Input, Segment } from 'semantic-ui-react'
import { UseForm } from '../Hooks/UseForm';
import { CerrarPopup } from '../Reducers/PopupReducer';
import Swal from 'sweetalert2'
import numeral from 'numeral';
import { ColocarOrdenAsync } from '../Servicios/ServiciosPublicos';

export const ColocarOrden = (params) => {
    const { MonedaDetalle } = params;
    const dispatch = useDispatch();

    const _useForm = UseForm();
    const { Entidad, SetEntidad, OnChange } = _useForm;

    //#region internalState
    const [internalState, setInternalState] = useState({
        Load: false,
        Tipos: [
            { key: 'compra', value: 'compra', text: 'Compra', },
            { key: 'venta', value: 'venta', text: 'Venta' },
        ]
    })
    //#endregion
    //#region useEffect
    useEffect(() => { Load(); }, []);
    //#endregion
    //#region Metodos
    const Load = async () => {
        console.log(MonedaDetalle);
        SetEntidad((state) => ({
            ...state,
            Importe: MonedaDetalle.Item.Disponible,
            Precio: MonedaDetalle.Item.UltimoPrecio,
            Tipo: { id: "compra" }
        }));

    }
    //#endregion
    const OnClickCerrar = () => { dispatch(CerrarPopup()); }
    const OnClickCrearOrden = async () => {
        let _ni = Entidad.Precio;
        _ni = +numeral(_ni).format("0.00");
        let _amount = +numeral(Entidad.Importe / +_ni).format("0.00000000");
        let _tipo = Entidad.Tipo.id;
        let _side = Entidad.Tipo.id === "compra" ? "buy" : "sell";
        let _strImporte = numeral(Entidad.Importe).format("0,000.00");
        let _strNI = numeral(_ni).format("0,000.00");
        let _strA = numeral(_amount).format("0,000.00000000");

        let _result = await Swal.fire({
            title: ``,
            html: `¿Deseas realizar una nueva Orden de <span class="${_tipo}">${_tipo}</span> Limitada por $ ${_strImporte} a $ ${_strNI} (${_strA})?`,
            icon: 'question',
            confirmButtonText: 'Si',
            showCancelButton: true,
            cancelButtonText: "No"
        });
        if (_result.value) {
            if (_strImporte) {
                _amount = +numeral(+_strImporte / +_ni).format("0.00000000");
                let _order = {
                    book: MonedaDetalle.Item.book,
                    side: _side,
                    type: "limit",
                    price: +_ni,
                    major: +_amount,
                };
                let r = await ColocarOrdenAsync(_order);
                let _result = await Swal.fire({
                    title: ``,
                    text: r.success ? "Se coloco la orden" : `${r.error.code} ${r.error.message}`,
                    icon: r.success ? 'success' : "error",
                    confirmButtonText: 'Aceptar',
                });
                if (r.success) { OnClickCerrar(); }
            }
        }

    }


    return (
        <>
            <div className='ui segments'>
                <Segment>
                    <Form>
                        <Form.Field>
                            <label>Tipo</label>
                            <Dropdown
                                clearable
                                name="Tipo"
                                placeholder='Compra / Venta'
                                fluid
                                search
                                selection
                                value={Entidad.Tipo?.id}
                                options={internalState.Tipos}
                                onChange={OnChange}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Precio</label>
                            <Input
                                // ref={txtUsuario}
                                name="Precio"
                                error={!Entidad.Precio}
                                placeholder='Precio'
                                style={{ width: "100%", marginBottom: "15px", marginTop: "15px" }}
                                onChange={OnChange}
                                value={Entidad.Precio}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Importe</label>
                            <Input
                                // ref={txtUsuario}
                                name="Importe"
                                error={!Entidad.Importe}
                                placeholder='Importe'
                                style={{ width: "100%", marginBottom: "15px", marginTop: "15px" }}
                                onChange={OnChange}
                                value={Entidad.Importe}
                            />
                        </Form.Field>
                    </Form>
                </Segment>
                <Segment basic textAlign="right">
                    <Button onClick={OnClickCrearOrden} positive>Crear Orden</Button>
                    <Button onClick={OnClickCerrar} negative>Cerrar</Button>
                </Segment>
            </div>
        </>
    )
}
